<script>
const THEME = {
  'default': 'text-green-400 bg-white'
};
const SIZE = {
  'default': 'py-[5px] px-3 rounded-md'
};

export default {
  name: 'WarrantyBadge',
  props: {
    text: {
      type: String
    },
    theme: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    themeClasses() {
      return THEME[this.theme];
    },
    sizeClasses() {
      return SIZE[this.size];
    },
  }
}
</script>
<template>
  <div
      :class="[themeClasses, sizeClasses]">{{ text }}</div>
</template>